export default __webpack_public_path__ + "static/media/tour-6.4fb67184.jpeg";